import classNames from 'classnames/bind';
import styles from './CardSideBack.module.scss';
import { Button, RichText, Grid, MinusIcon} from '@/components';

let cx = classNames.bind(styles);

export default function CardSideBack({cardAttr, setIsFlipped}) {
	function flipCartoFront(e) {
		setIsFlipped(false);
	}
  return (
    <Grid className={cx(['card-back-grid'])} alignItems="center" colCount={cardAttr.cardLayout === 'Side-by-side' ? 2 : 1}>
      <div className={cx('content-container')}>
        {cardAttr.backText && <RichText html={cardAttr.backText} />}
        {cardAttr.backCta?.url && cardAttr.backCta?.title && <Button href={cardAttr.backCta.url} outlined={cardAttr.backCtaStyle}>{cardAttr.backCta.title}</Button>}
      </div>
      <button className={cx('minus-icon')} onClick={flipCartoFront}>
        <MinusIcon />
        <span className="sr-only">Close</span>
      </button>
    </Grid>
  );
}
